let language = {
    "CATALOG-SEARCH-CONTAINER-TITLE": "搜索结果",
    "CATALOG-SEARCH-MENU-LIST-TITLE": "排序方式",
    "CATALOG-SEARCH-MENU-LIST-NEW": "新品",
    "CATALOG-SEARCH-MENU-LIST-PRICE": "价格",
    "CATALOG-SEARCH-MENU-LIST-LOW-HIGH": "低 - 高",
    "CATALOG-SEARCH-MENU-LIST-HIGH-LOW": "高 - 低",
    "CATALOG-SEARCH-PLACE-HOLDER-SEARCH": "搜索",
    "CATALOG-SEARCH-EMPTY-TIPS": "请输入关键词",
    "CATALOG-SEARCH--CATALOG-EMPTY-TIPS": "目录中的产品为空",
    "CATALOG-SEARCH--CATALOG-LIST-PRICE-TITLE": "低至",
    "CATALOG-SEARCH--CATALOG-BUTTON-BACK": "返回",
};

export { language }
